import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AuthService } from 'src/app/services/auth.service';
import { RequestStatus } from 'src/app/shared/data/models';
import { SubSink } from 'subsink';

@Component({
  selector: 'app-recovery',
  templateUrl: './recovery.component.html',
  styleUrls: ['./recovery.component.scss']
})
export class RecoveryComponent implements OnInit, OnDestroy {

  private subs = new SubSink();
  public statusDetail: RequestStatus = 'init';
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { status: RequestStatus },
    public dialogRef: MatDialogRef<RecoveryComponent>,
    private auth: AuthService,
  ) { };

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  };

  ngOnInit(): void {
    this.statusDetail = this.data.status;
  };

  public confirmButton(confrm: boolean): void {
    this.dialogRef.close(confrm);
  };

}
